import { FC } from 'react';
import { listOfSportIdToShowServingTeamBallIcon } from 'shared/constants/common';
import './styles.scss';

type Props = {
	sportId: number;
};

export const ServingTeamIcon: FC<Props> = ({ sportId }) => {
	const isShowServingTeamBallIcon = listOfSportIdToShowServingTeamBallIcon.includes(sportId);

	if (isShowServingTeamBallIcon) {
		return <div className="servingTeamIcon" />;
	}

	return <></>;
};
